module.exports = __webpack_public_path__ + "img/logotipo-nexoagentes-b.5991660c.png";